// Module
var code = "<bb-loading has-loaded=\"vm.dataLoaded\">\n  <listing-view\n    listing=\"vm.listing\"\n    assets=\"vm.assets\"\n    external=\"true\"\n    ng-if=\"vm.listing\"\n  />\n</bb-loading>\n";
// Exports
module.exports = code;